import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class ProfileElementGroup extends DataModel {
  static readonly TYPE_ID: string = 'b5f2b365e9a7423580c942db35427fd0';

  constructor(
    public readonly uniqueId: string,
    public readonly name: string,
  ) {
    super();
  }

  get $typeId(): string {
    return ProfileElementGroup.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfileElementGroup {
    return new ProfileElementGroup(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'name'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'name': this.name,
    };
  }

  clone(): this {
    return new ProfileElementGroup(
        this.uniqueId,
        this.name,
    ) as this;
  }

  isSame(other: ProfileElementGroup): boolean {
    if(this === other) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
          other.name === this.name;
  }
}

export class ProfileElementGroupBuilder extends DataModelBuilder<ProfileElementGroup> {
  build(context: SerializationContext, map: SerializedData): ProfileElementGroup {
    return ProfileElementGroup.fromMap(context, map);
  }
}
